import { jsx } from "../../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/react/jsx-runtime.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.es.es.js";
import "react";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.es.es.js";
import "@mui/material";
import { CalendarOutlined as o } from "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/calendar-outlined.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/turn-icons.es.es.js";
import { Background } from "../../../foundations/palette.es.js";
import { CursorStyle } from "../../../foundations/cursor-style.es.js";
const mobileDatePickerTextFieldStyleOverrides = {
  "& .MuiOutlinedInput-root": {
    "&:has([readonly])": {
      backgroundColor: Background.paper,
      cursor: CursorStyle.pointer
    }
  },
  "& .Mui-readOnly": {
    cursor: CursorStyle.pointer
  }
};
const mobileDatePickerTextFieldDisabledStyleOverrides = {
  "& .MuiOutlinedInput-root": {
    "&:has([readonly])": {
      backgroundColor: Background.paper
    }
  }
};
function generateCustomTextFieldStyle(disabled) {
  const iconColor = disabled ? "disabled" : "action";
  return {
    sx: disabled ? mobileDatePickerTextFieldDisabledStyleOverrides : mobileDatePickerTextFieldStyleOverrides,
    InputProps: {
      endAdornment: /* @__PURE__ */ jsx(o, { color: iconColor })
    }
  };
}
export {
  generateCustomTextFieldStyle
};
//# sourceMappingURL=date-picker-functions.es.js.map
